import axios from "axios";
import { createTransactionID } from "../utils";

const win: any = window;

let config = {
  api: {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Correlation-Id": createTransactionID(true),
      "X-Journey-Name": "FTTH_Installation_Request"
    },
  },
};

export const api = axios.create({ ...config.api });
export const simpleApi = axios.create();

api.defaults.validateStatus = function () {
  return true;
};

api.interceptors.request.use(
  async (conf: any) => {
    conf.baseURL = win["apigee_bm_base_url"];
    conf.headers['cem-key'] = win["cem_key"];
    conf.headers['x-api-key'] = win["cem_key"];
    conf.headers["X-Source-Channel"] = "PORTAL";
    conf.headers["x-channel-id"] = "PORTAL";
    conf.headers["X-Transaction-Id"] = createTransactionID();
    if (!conf.headers["Authorization"]) conf.headers["Authorization"] = `Bearer ${win['bmToken']}`;

    return conf;
  }, (err) => {
    console.log("error in getting ", err);
  }
);

api.interceptors.response.use(
  async (response: any) => {
    return response;
  }, async (error: any) => {
    if (!!win["errorPageURL"]) {
      document.location.href = win['base_portal_url'] + win["errorPageURL"];
    }
    return error;
  }
);

const resendOtp = (data: any) => {
  return api.put('/cem/bff/otp/v1/resend', data);
};

const initiateLogin = (data: any) => {
  const url = `/cem/bff/login/v1/initiate`;
  return api.post(url, data);
  // return api.get('http://localhost:3001/cemInitiateOTP', data)
};

const validateAuth = (data: any) => {
  const url = `/cem/bff/login/v1/validate`;
  return api.post(url, data);
  // return api.get('http://localhost:3001/cemValidateOTP', data)
};

const cancellationReason = (data: any) => {
  // return api.get('http://localhost:3001/cancellationReason')
  return api.post(`/api/dp/v1/mip/tcc/cstGetCancelReasonCodes`, data)
}

const cstCancelFiberInstallationByCustomer = (data: any) => {
  // return api.get('http://localhost:3001/cancellationReason')
  return api.post(`/api/dp/v1/mip/tcc/cstCancelFiberInstallationByCustomer`, data)
}

const getRequestDetails = (req: any, accessToken: string) => {
  // return api.get('http://localhost:8001/getRequestLists')
  return api.post(`cem/order-generator/ftth-installation/v1/orderInquiry`, req, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })
}

const getNationality = () => {
  return api.get('api/digital/v1/data/mappings?contextId=CTX_LOOKUPS&catalogKey=online_sales_lookups');
}

const getODBCancelOTP = (encryptedMnpNumber: any, lang: any) => {
  let data = {
    "version": "v1",
    "journey": "CANCEL_ODB_REQUEST",
    "operation": "SEND_OTP",
    "language": lang,
    "extraInfo": [
      {
        "key": "ACCOUNT_NUMBER",
        "value": encryptedMnpNumber
      },
      {
        "key": "OTP_LENGTH",
        "value": "4"
      },
      {
        "key": "IS_NUMERIC",
        "value": "Y"
      }
    ]
  }
  return api.post(`/cem/bff/otp/v1/send`, data);
  // return api.get(`http://localhost:3002/send`);
}

const submitODBCancelOTP = (otp: any, refId: any) => {
  const data = {
    "operation": "VALIDATE_OTP",
    "extraInfo": [
      {
        "key": "REF_ID",
        "value": refId
      },
      {
        "key": "OTP",
        "value": otp
      }
    ]
  }
  return api.put('/cem/bff/otp/v1/validate', data);
  // return api.get('http://localhost:3002/validate');
}
export {
  resendOtp,
  initiateLogin,
  validateAuth,
  getRequestDetails,
  getNationality,
  cancellationReason,
  getODBCancelOTP,
  submitODBCancelOTP,
  cstCancelFiberInstallationByCustomer
};